export const CONSOLES_ACTIONS = {
  consoles: {
    request: "CONSOLES/FETCH_REQUEST",
    success: "CONSOLES/FETCH_SUCCESS",
    error: "CONSOLES/FETCH_ERROR"
  },
  resetState: "CONSOLES/RESET_STATE"
};
